import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../../../core/constants/api-endpoints';
import { HttpService } from '../../../core/services/http/http.service';
import type {
  CreateWorkspaceSubscriptionRequest,
  WorkspaceSubscriptionApiResponse,
} from '../billing-subscription.models';

@Injectable({ providedIn: 'root' })
export class BillingSubscriptionApiService {
  private readonly http = inject(HttpService);

  getSubscription(): Observable<WorkspaceSubscriptionApiResponse> {
    return this.http.get<WorkspaceSubscriptionApiResponse>(
      API_ENDPOINTS.BILLING.SUBSCRIPTION,
      { withCredentials: true },
    );
  }

  subscribe(
    body: CreateWorkspaceSubscriptionRequest,
  ): Observable<WorkspaceSubscriptionApiResponse> {
    return this.http.post<WorkspaceSubscriptionApiResponse>(
      API_ENDPOINTS.BILLING.SUBSCRIPTION,
      body,
      { withCredentials: true },
    );
  }
}
